export default `
	guid
	email
	type
	time
	for_date
	active
	
	language {
		guid
	}
	building {
		guid
	}
	timeslot_kind {
		guid
	}
`;
